import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import CoachName from './CoachName';
import CoachType from './CoachType';
import CoachDescription from './CoachDescription';
import ActivityGroupList from '../ActivityGroupList/CoachActivityGroupListContainer';

const Infos = styled.div`
  background-color: #fff;
  flex: 1;
  flex-direction: column;
  display: flex;
  padding: 0 20px;
  align-items: ${props => (props.align ? props.align : null)};
`;

const CoachInfos = ({ coach, align, margin }) => (
  <Infos align={align}>
    <CoachName>
      {coach.name} {coach.surname}
    </CoachName>
    <CoachType>{coach.type}</CoachType>
    <CoachDescription>{coach.description}</CoachDescription>
    <ActivityGroupList coach={coach} margin={margin} />
  </Infos>
);

CoachInfos.propTypes = {
  coach: PropTypes.shape({}),
  align: PropTypes.string,
  margin: PropTypes.string
};

CoachInfos.defaultProps = {
  coach: {},
  align: undefined,
  margin: undefined
};

export default CoachInfos;



// WEBPACK FOOTER //
// ./src/components/CoachInfos/CoachInfos.jsx